module.exports = __webpack_public_path__ + "img/step3.43339c5c.png";